module.exports = __webpack_public_path__ + "img/tour-start.68181fce.svg";